import api from '../../utils/api';

export const removeUnitModel = (id: number) =>
  api.delete({
    url: `/unit-model/${id}`,
  });
